import CustomDropdown from "components/common/customDropdown"
import CustomDatePicker from "pages/NewReports/Sales/CategoryReport/CustomDatepicker"
import React, { forwardRef } from "react"
import { DateObject, DatePickerRef } from "react-multi-date-picker";
// import SingleDatePicker from "../SingleDatePicker";
import "../StoreFilter/StoreFilter.scss"

interface CustomDatePickerDropDownProps {
  classNamePicker?: string;
  onSelect: (option: any) => void;
  options: any[];
  value: any;
  placeholderClass?: string;
  className?: string;
  containerClassName?: string;
  handleOnChange: (dates: any) => void;
  selectedDates?: any;
  setSelectedDates?: (dates: any) => void;
  datePickerContainerClassName?: string;
  applyBtnOnclick: () => void;
  closeBtnOnclick: () => void;
  render: React.ReactNode;
  arrowClassName?: string;
  offsetY?: number;
  isSingleDatePicker?: boolean;
  maxDate?: DateObject | Date | string | number;
  minDate?: DateObject | Date | string | number;
}

const CustomDatePickerDropDown = forwardRef<DatePickerRef, CustomDatePickerDropDownProps>((props, ref) => {
  const {
    classNamePicker,
    onSelect,
    options,
    value,
    placeholderClass,
    className,
    containerClassName,
    handleOnChange,
    selectedDates,
    setSelectedDates,
    datePickerContainerClassName,
    applyBtnOnclick,
    closeBtnOnclick,
    render,
    arrowClassName,
    offsetY,
    isSingleDatePicker = false,
    maxDate,
    minDate,
  } = props;

  return (
    <div className="category-dropdown-container events-category-dropdown-container">
      <div className="category-dropdown-sub-container">
        <span className="category-dropdown-text">Select date</span>
        <CustomDropdown
          onSelect={onSelect}
          options={options}
          value={value}
          placeholderClass={placeholderClass}
          className={className}
        />
        {/* {isSingleDatePicker ?
          <SingleDatePicker
            hideMenu={true}
            selectedDate={selectedDates}
            setSelectedDate={setSelectedDates}
            minDate={minDate}
            maxDate={maxDate}
            handleDateChange={handleOnChange}
          />
          : */}
          <CustomDatePicker
            containerClassName={containerClassName}
          handleOnChange={handleOnChange}
            selectedDates={selectedDates}
            datePickerContainerClassName={datePickerContainerClassName}
            ref={ref}
            applyBtnOnclick={applyBtnOnclick}
            closeBtnOnclick={closeBtnOnclick}
            className={classNamePicker}
            render={render}
            arrowClassName={arrowClassName}
            offsetY={offsetY}
            maxDate={maxDate}
            minDate={minDate}
          />
        {/* } */}
      </div>
    </div>
  );
});

CustomDatePickerDropDown.displayName = 'CustomDatePickerDropDown';

export default CustomDatePickerDropDown;